import React from "react";

import {Typography} from "@mui/material";
import {typografNode} from "../../utils/typograf";
import {SxProps} from "@mui/material/styles";

type MenuProps = {
    children: React.ReactNode;
    sx?: SxProps;
};

function Menu({children, sx}: MenuProps) {
    return (
        <Typography sx={{
            fontFamily: 'Roboto, sans-serif',
            letterSpacing: 0,
            '@media screen and (min-width: 1400px)': {
                fontSize: '16px',
                lineHeight: 1.6,
            },
            '@media screen and (min-width: 1200px) and (max-width: 1399px)': {
                fontSize: '16px',
                lineHeight: 1.6,
            },
            '@media screen and (min-width: 992px) and (max-width: 1199px)': {
                fontSize: '14px',
                lineHeight: 1.71,
            },
            '@media screen and (min-width: 768px) and (max-width: 991px)': {
                fontSize: '14px',
                lineHeight: 1.71,
            },
            '@media screen and (max-width: 767px)': {
                fontSize: '12px',
                lineHeight: 1.5,
            },
            ...sx
        }}>
            {typografNode(children)}
        </Typography>
    );
}

export default Menu
